import axios from 'axios'
import { API_ADDRESS } from 'config'
import { SuburbConfig } from 'config/constants/types'
import { CouncilsListing } from 'state/types'

export const getSuburbListings = async (suburbId: string, ownerId: string): Promise<CouncilsListing[]> => {
  const url = `${API_ADDRESS}/admin/councils/list-listings?suburbId=${suburbId}&ownerId=${ownerId}`
  const { data } = await axios.get(url)

  return data
}

export const getSuburbCsv = async (suburbId: string, ownerId: string, search?: string): Promise<any> => {
  const url = `${API_ADDRESS}/admin/councils/csv-listings?suburbId=${suburbId}&ownerId=${ownerId}${search ? `&search=${search}` : ''}`
  const { data } = await axios.get(url)

  return data
}

export const getSuburbByNameAndState = async (name: string, state: string): Promise<any> => {
  const url = `${API_ADDRESS}/suburb/suburb?name=${name}&state=${state}`
  const { data } = await axios.get(url)

  return data
}

export const getSuburbListingsSuburb = async (suburbId: string): Promise<SuburbConfig> => {
  const url = `${API_ADDRESS}/admin/get-suburb?suburbId=${suburbId}`
  const { data } = await axios.get(url)

  return data
}
